import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { showErrorToast } from '../../../components/atoms/Utlis/Toast';
import { getAllInvoicesAPI, createInvoiceAPI } from '../../ApiCalls/Dashboard/InvoiceAPI';
import { InvoiceState } from '../../Slice/Dashboard/InvoiceSlice';

export const InvoiceReducer = (builder: ActionReducerMapBuilder<InvoiceState>) => {
  builder
    .addCase(getAllInvoicesAPI.pending, (state) => {
      state.loading = true;
      state.isError = false;
      state.error = {};
    })
    .addCase(getAllInvoicesAPI.fulfilled, (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.isError = false;
      state.allInvoices = action.payload?.results || action.payload || [];
      state.totalCount =
        action.payload?.count ||
        (action.payload?.results
          ? action.payload.results.length
          : action.payload?.length) ||
        0;
    })
    .addCase(getAllInvoicesAPI.rejected, (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.isError = true;
      if (action.payload && action.payload.message) {
        showErrorToast(action.payload.message);
      }
    })

    .addCase(createInvoiceAPI.pending, (state) => {
      state.submitting = true;
      state.isError = false;
      state.error = {};
    })
    .addCase(createInvoiceAPI.fulfilled, (state) => {
      state.submitting = false;
      state.isError = false;
    })
    .addCase(createInvoiceAPI.rejected, (state, action: PayloadAction<any>) => {
      state.submitting = false;
      state.isError = true;
      if (action.payload && action.payload.message) {
        showErrorToast(action.payload.message);
      } else {
        console.log(action.payload);
      }
    });
};
